import { useState, useEffect } from 'react';

// tracks whether user has interacted with page. Useful for starting audio context
export const useHasInteracted = () => {
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() => {
    // apparently chrome on mobile doesn't consider touch or pointer events sufficient
    // and if I add them here, they may fire first, making audio attempt to start, but failing
    // ['click', 'touchstart', 'pointerdown'];
    const events = ['click'];

    const handleInteraction = () => {
      setHasInteracted(true);
    };

    const removeHandlers = () => {
      events.forEach(event => {
        document.removeEventListener(event, handleInteraction);
      });
    }

    // remove all handlers once interacted
    if (hasInteracted) {
      removeHandlers();
      return
    }

    events.forEach(event => {
      document.addEventListener(event, handleInteraction);
    });

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, handleInteraction);
      });
    };
  }, [hasInteracted]);

  return hasInteracted;
};

